import React from "react";
import { Outlet } from "react-router-dom";

//
import { Col, Row, Card } from "react-bootstrap";

//
import Logo from "../assets/img/logo.png";

const StripeCallback = () => {

  return (
    <div className="container-fluid" >
      <Row id="stripe-callback">
        <Col xs={12}>
          <img src={Logo} alt="logo" className="logo" />
        </Col>

        <Col md={5} lg={4} xxl={3} className="stripe-box">
          <Card>
            <Card.Body>
              <Outlet />
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12}>
          <div></div>
        </Col>
      </Row>
    </div>
  )
  
};
export default StripeCallback;
